import { ReactElement } from 'react';

import { useTheme } from '@mui/material/styles';

import { Icon } from '../../icon';
import { DestructiveButton } from '../../style/button';
import { ButtonSize } from '../basic-button/basic-button';

type DeleteButtonProps = {
  onClick: () => void;
  sizeVariant?: ButtonSize;
  disabled?: boolean;
  title?: string;
  sx?: object;
};

export const DeleteButton = ({
  onClick,
  disabled = false,
  title = 'Delete Selected',
  sx,
}: DeleteButtonProps): ReactElement => {
  const theme = useTheme();
  return (
    <DestructiveButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        color: theme.text?.astrik,
        gap: 2,
        ...sx,
      }}
    >
      <Icon name={'DeleteSVG'} />
      {title}
    </DestructiveButton>
  );
};
